var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.targetClass},[_c('no-ssr',[_c('mq-layout',{attrs:{"mq":['m480', 'm576', 'm768']}},[_vm._t("default")],2)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }